import { jsx } from "@emotion/react/jsx-runtime";
import { Loader } from "@datacamp/waffles/loader";
import { useTranslation } from "react-i18next";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1wwk2bk",
  styles: "width:150px"
} : {
  name: "1maick2-PageLoader",
  styles: "width:150px;label:PageLoader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9tbnQvcmFtZGlzay9wYWNrYWdlcy91aS9zcmMvY29tcG9uZW50cy9QYWdlTG9hZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPUyIsImZpbGUiOiIvbW50L3JhbWRpc2svcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvUGFnZUxvYWRlci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBMb2FkZXIgfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy9sb2FkZXInO1xuaW1wb3J0IHsgdXNlVHJhbnNsYXRpb24gfSBmcm9tICdyZWFjdC1pMThuZXh0JztcblxuY29uc3QgUGFnZUxvYWRlcjogUmVhY3QuRkMgPSAoKSA9PiB7XG4gIGNvbnN0IHsgdCB9ID0gdXNlVHJhbnNsYXRpb24oKTtcblxuICByZXR1cm4gKFxuICAgIDxkaXYgY3NzPXt7IHdpZHRoOiAnMTUwcHgnIH19PlxuICAgICAgPExvYWRlciBhcmlhLWxhYmVsPXt0KCdQYWdlTG9hZGVyLmxhYmVsJyl9IC8+XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBQYWdlTG9hZGVyO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const PageLoader = () => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsx("div", { css: _ref, children: /* @__PURE__ */ jsx(Loader, { "aria-label": t("PageLoader.label") }) });
};
export {
  PageLoader as default
};
